<template>
  <div style="line-height: 2.2rem; background-color: #eee; padding: 1rem; margin-bottom: 1rem">
    <!-- {{ sTimeTip }} -->

    <div v-if="sTimeTip">
      <div>
        最後可點餐時間<van-tag plain>{{ sTimeTip.timeE.substr(11, 5) }}</van-tag>
      </div>
      <div>
        開桌時間
        <van-tag plain>{{ sTimeTip.timeB.substr(11, 5) }}</van-tag>
      </div>
    </div>
    <div>
      每單送單時間需間隔<span class="C2"> {{ sTimeTip.span }} </span>分鐘
    </div>
    <div>
      每次送單數量上限:<span class="C2"> {{ sTimeTip.maxQty }} </span>
    </div>
    <div>
      剩餘可點時間<van-tag size="small" plain :color="diff == '逾時' ? 'red' : ''">{{ diff }}</van-tag>
    </div>
    {{  }}
    <div v-if="Number(sGetConfig('BNS_MaxDiningTime')) > 0">
      離座時間<van-tag plain>{{ sTimeTip.maxDiningTime.substr(11, 5) }}</van-tag>
    </div>
    <!-- <pre>{{ sTimeTip }}</pre> -->
  </div>
</template>
<style scoped>
.van-tag {
  margin: 0 0.5rem 0rem 0.5rem;
  font-size: 1rem;
  padding: 0.5rem;
  color: v-bind(sGetConfig("color2"));
  /* border-radius: 1rem; */
}
</style>
<script>
import moment from 'moment'
export default {
  components: {},
  mounted() {
    this.main();
  },
  data() {
    return {
      diff: "hh:mm",
    };
  },
  methods: {
    main() {
      setInterval(() => {
        try {
          let timee = moment(this.sTimeTip.timeE);
          let mm = moment().diff(timee, "m");
          // console.log("mm",mm);
          if (mm > 0) return this.diff = "逾時";

          this.diff = mm * -1 + "分鐘";

        } catch (error) {
          console.log(error);
          this.diff = "";
        }
      }, 1000);
    },
  },
};
</script>
